import script from "./EditPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPassword.vue?vue&type=script&setup=true&lang=js"

import "./EditPassword.vue?vue&type=style&index=0&id=3cee5e4d&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cee5e4d"]])

export default __exports__